import { BehaviourSettings } from "../../../models/account";
import "./AccountBehaviourSettings.css";
import { wordFromCamelCase } from "../../../utilities/FormatHelpers";
import { Divider, Label } from "semantic-ui-react";
import { useEffect, useState } from "react";
export default function CurrentAccountBehaviourSettings(props: {behaviourSettings: BehaviourSettings}) { 
  const [changedBehaviourSettings, setChangedBehaviourSettings] = useState<string[]>([]);

  const settingHasChanged = (setting: string) => { 
    return changedBehaviourSettings?.includes(setting);
  }

  useEffect(() => {
    const previousSettings = localStorage.getItem('behaviourSettings');
    setTimeout(() => { 
      localStorage.setItem('behaviourSettings', JSON.stringify(props.behaviourSettings));
      const changedSettings = Object.keys(props.behaviourSettings).filter(setting => {
        return previousSettings ? JSON.parse(previousSettings)[setting] !== props.behaviourSettings[setting] : false;
      });
      if(changedSettings.length > 0) {
        setChangedBehaviourSettings(changedSettings);
        console.log('changed settings', changedSettings);
      }
    }, 300)

  }, [props.behaviourSettings, changedBehaviourSettings])


  const settings = Object.keys(props.behaviourSettings);

    return (
            <div className="ui segment">
              <div className="ui header">Current Behaviour Settings</div>
              <div className={`content behaviour-settings`}>
                    {settings.map((setting, key) => (
                      <div key={key}>
                        <div className="row" key={setting}>
                          <strong className="large">
                            {wordFromCamelCase(setting)}
                          </strong>
                          <Label className={ `${settingHasChanged(setting) ? 'has-changed' : ''}`}>{" " + props.behaviourSettings[setting].toUpperCase()}</Label>
                        </div>
                          <Divider className="behaviour-divider"/>
                      </div>

                    ))}

              </div>
            </div>
        );
}
